import { c as _c } from "react/compiler-runtime";
import { addDays } from 'date-fns';
import { useContext } from 'react';
import { TransformationExecution } from '../../../../../typings/TransformationExecution.interface';
import APIMethodKeys from '../../client/APIMethodKeys';
import { TransformationExecutionsFiltersProps } from '../../typings/TransformationExecution.interface';
import { GlobalContext } from '../contexts/GlobalContext';
import useRefreshingList, { RefreshingListResult } from './useRefreshingList';
export const formatFiltersForAPI = (filters: TransformationExecutionsFiltersProps = {}) => {
  const formatted_filters: {
    [k: string]: any;
  } = {};
  if (filters.date?.min || filters.date?.max) {
    formatted_filters['created_at'] = {
      gte: filters.date.min,
      lte: filters.date.max && addDays(new Date(filters.date.max), 1).toISOString()
    };
  }
  formatted_filters.next = filters.next;
  formatted_filters.prev = filters.prev;
  formatted_filters.webhook_id = filters.webhook_id?.length === 0 ? undefined : filters.webhook_id;
  formatted_filters.log_level = filters.log_level?.length === 0 ? undefined : filters.log_level;
  formatted_filters.issue_id = filters.issue_id;
  return formatted_filters;
};
export interface TransformationExecutionListResult extends Omit<RefreshingListResult<Request>, 'models'> {
  executions: TransformationExecution[];
}
const useTransformationExecutionsList = (transformation_id, filters) => {
  const $ = _c(15);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t0;
  if ($[0] !== filters) {
    t0 = formatFiltersForAPI({
      ...filters
    });
    $[0] = filters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const formatted_filters = t0;
  let t1;
  if ($[2] !== transformation_id) {
    t1 = query => APIMethodKeys.transformations.listExecutions(transformation_id, query);
    $[2] = transformation_id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getKey = t1;
  let t2;
  if ($[4] !== HookdeckAPI.transformations || $[5] !== transformation_id) {
    t2 = query_0 => HookdeckAPI.transformations.listExecutions(transformation_id, query_0);
    $[4] = HookdeckAPI.transformations;
    $[5] = transformation_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const list = t2;
  const t3 = filters.limit || 50;
  let t4;
  if ($[7] !== t3) {
    t4 = {
      limit: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = useRefreshingList(getKey, list, formatted_filters, "created_at", "DESC", t4);
  let executions;
  let props;
  if ($[9] !== t5) {
    ({
      models: executions,
      ...props
    } = t5);
    $[9] = t5;
    $[10] = executions;
    $[11] = props;
  } else {
    executions = $[10];
    props = $[11];
  }
  let t6;
  if ($[12] !== executions || $[13] !== props) {
    t6 = {
      executions,
      ...props
    };
    $[12] = executions;
    $[13] = props;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default useTransformationExecutionsList;